import { useEffect } from "react"
import { useAppDispatch } from "integrations/redux/hooks"
import { setOverlaySceneTime } from "features/map/control/slice"
import { OverlayKey } from "features/map/control/types"

export function useReportOverlaySceneTime(key: OverlayKey, sceneTime: number) {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(setOverlaySceneTime({ key, sceneTime }))
    }, [key, sceneTime, dispatch])
}
